import * as THREE from 'three';

export default class TopVew2D {
    con: any

    constructor(id: string, right: number, top: number, container: HTMLElement) {
      this.con = document.createElement('div');
      this.con.id = id;
      container.appendChild(this.con);
    }

    public update = (px: number, pz: number, q: THREE.Quaternion) => {
      console.log(px, pz, q);
    }

    // 表示
    public element = () => this.con

    // 表示
    public show = () => {
      this.con.style.visibility = 'visible';
    }

    // 非表示
    public hide = () => {
      this.con.style.visibility = 'hidden';
    }

    // 平面図の描画 @param floor:int = 表示階
    public drawTopView = (floor: number) => {
      console.log(floor);
    }
}
